import { FC, useMemo, useState } from "react"
import useAxios from "@/hooks/useAxios";
import { useCallback, useEffect } from "react";
import ImageList from "@/components/list";
import styles from "@/components/styles/layoutContent.module.css"
import u, { ELocalKey } from "@/util";
import isMobile from "@/util";
import useCategory from "@/hooks/useCategory";
import useConfBase from "@/hooks/useConfBase";
import NoticeModal from "@/components/modal/noticeModal";
import { EModalTypes, modalSubject$ } from "@/hooks/useModal";
import useFlipFlop from "@/hooks/useFlipFlop";
import Img from "@/components/img";
import { relative } from "path";
import { position } from "html2canvas/dist/types/css/property-descriptors/position";
import useUser from "@/hooks/useUser";
import { generateFullUrl, appendHost } from "@/const/append";



interface ILayoutContent {
    list: any[]
}

const LayoutContent: FC<ILayoutContent> = ({ list }) => {
    const { req } = useAxios("index/home", 'post',);
    const { req: reqNotice } = useAxios("notice/list", 'post',);
    const { req: reqStats } = useAxios("index/statistics", "post", true);
    const { req: ReqTupian } = useAxios("new-pic/main-topics", 'post',);
    const [data, setData] = useState<any>({})
    const [config] = useConfBase()
    const category = useCategory()
    const [flipText, flipHander] = useFlipFlop("登录", "登录中...")
    const [PostBarMM, setPostBarMM] = useState<any>()
    const [GongLie, setGongLie] = useState<any>()
    const [TuPian, setTuPian] = useState<any>()
    const [error, setError] = useState<string | null>(null);   // Store error if any
    const [userInfo] = useUser();


    const sourcurl = process.env.REACT_APP_STATIC_POSTBAR_MM_SRC;
    const gonglieurl = process.env.REACT_APP_STATIC_GONGLIE_SRC;

    useEffect(() => {
        const fetchPostBarMM = async () => {
            try {
                const result = await u.getPostBarMM(sourcurl,)
                console.log('Fetched data structure REACT_APP_STATIC_POSTBAR_MM_SRC:', result);
                setPostBarMM(result);
            } catch (err) {
                setError('Failed to fetch comments REACT_APP_STATIC_POSTBAR_MM_SRC.');
            }
        };

        fetchPostBarMM();
    }, [sourcurl])

    useEffect(() => {
        const fetchMMGongLie= async () => {
            try {
                const result = await u.getPostBarMM(gonglieurl,)
                console.log('Fetched data structure gong lie:', result);
                setGongLie(result);
            } catch (err) {
                setError('Failed to fetch gong lie.');
            }
        };

        fetchMMGongLie();
    }, [gonglieurl])

    useEffect(() => {
      const fetchMMTuPian= async () => {
          try {
              const result = await ReqTupian({ limit: "4" })
              console.log('fetched tupian:', result);
              setTuPian(result?.data);
          } catch (err) {
              setError('Failed to fetch tu pian.');
          }
      };

      fetchMMTuPian();
  }, [ReqTupian])

    const fetchVIPVideo = useCallback(async (config2 : any) => {
        const res = await req({ channel: "vip" })
        
        if (res?.data) {
            console.log(' home index --- ', res);
            setData(res?.data)
        }


        console.log('load config2 --- ', config2)
        if(!config2?.mm_web_image_domain) return;
        console.log('loaded config2 --- ', config2)

        const res2 = await reqNotice({site: '1', type:1, is_mobile: 0});
        console.log('notice---' , res2)
       
        try{
            if(res2 && res2?.data?.notice && Array.isArray(res2?.data?.notice) && res2?.data?.notice.length === 0){
                // no show
            }else{
                if(res2 && res2?.data?.notice && new Date().getHours().toString() !== localStorage.getItem(ELocalKey._NOTICE)){
                    localStorage.setItem(ELocalKey._NOTICE, new Date().getHours().toString());

                    let imgUrls: any = [];
                    if(res2?.data && res2?.data?.notice){
                        console.log('notice result---' , res2?.data?.notice)
                        if(res2?.data?.notice && res2?.data?.notice.length > 0){
                            res2?.data?.notice.map((noticeItem: any)=>{
                                if(noticeItem?.pic_1){
                                    imgUrls.push(`${noticeItem?.pic_1}`);
                                    // imgUrls.push(`${config2?.mm_web_image_domain}/${noticeItem?.pic_1}`.includes('.txt')?`${config2?.mm_web_image_domain}/${noticeItem?.pic_1}`:`${config2?.mm_web_image_domain}/${noticeItem?.pic_1}.txt`);
                                }
                            })
                        }
                    }
                    console.log(imgUrls, 'notice result imgUrls---' , config2 , "---",config2?.mm_web_image_domain )

                    modalSubject$.next({
                        id: EModalTypes.NOTICE,
                        data: {data: res2?.data?.notice,imgs: imgUrls},
                        event: () => flipHander(0)
                    })
                }
            }
        } catch(err) { }        
    }, [])

    useEffect(() => {
        fetchVIPVideo(config)
    }, [fetchVIPVideo, config])

    const menuHandler = useCallback(
        async (type: string, path = null) => {
            const __val = u.getStatsParams(false, "", "", window.location.pathname);
    
            let categoryToSend;
            let name;
            
            // Set the category and name based on the type
            switch (type) {
                case "novel":
                    categoryToSend = "novel";
                    name = "成人小说";
                    break;
                case "pic":
                    categoryToSend = "pic";
                    name = "写真图库";
                    break;
                case "download":
                    categoryToSend = "cili";
                    name = "磁力资源";
                    break;
                case "luntan":
                    categoryToSend = "luntan";
                    name = "猫咪论坛";
                    break;
                default:
                    return;
            }
    
            // Request parameters
            req({ ...__val, category: categoryToSend, name });
    
            let token = '';
            let __data = localStorage.getItem("_USER");
               if(__data){
                let user = JSON.parse(u.decrypt(__data));
                token = user.token;
            }

            // Handle URL based on environment
            // if (process.env.NODE_ENV === "production") {
                const prefix = `${type}.`; // "novel.", "pic.", "download.", or "luntan."
                let urlary = window.location.origin.split("https://") as any;
                if (urlary.length === 1) {
                    urlary = window.location.origin.split("http://") as any;
                }
                if (urlary.length === 2) {
                    urlary[0] = prefix;
                }
                urlary = urlary.join("").replace("www.", "");
                if(path){
                  urlary = urlary + path;
                }
                if(token){
                    if (type === 'luntan') {
                        urlary += ('?mm=' + token);
                    } else if (type === 'pic') {
                        urlary += ('?mmp=' + token);
                    }
                }
                return u.open(`https://${urlary}`);
            // }
    
            // Fallback URLs for development environment
            // switch (type) {
            //     case "novel":
            //         return u.open(config?.novel_url);
            //     case "pic":
            //         return u.open(config?.pic_url);
            //     case "download":
            //         return u.open(config?.cili_url);
            //     case "luntan":
            //         return u.open(config?.luntan_url);
            // }
        },
        []
    );

    const handleMore = useCallback((row: any) => {
        hitStatis(row)

        try{
            if(window.location.href.includes("mmt=JDB2QGtySDdWMg==")){
                alert(row?.channel + '-' + u.isVip());
            }

            let __data = localStorage.getItem("_USER");
            if(__data){
                let userinfo = JSON.parse(u.decrypt(__data));
                if(userinfo && userinfo.username){
                    u.sendVIPLogDomain(userinfo.username, 'from main content - ' + row?.channel + '-' + u.isVip() + '[r] - ' + ((row?.channel === "vip" || row?.channel === "remen") && !u.isVip()));
                }
            }
        }catch(e){}

        if ((row?.channel === "vip" || row?.channel === "remen") && !u.isVip()) {
            return window.open("/user/buy")
        }
        if (row?.channel && row?._name) {
            if(row?.channel === 'topic'){
                return window.open(`/page/${row?.channel}/${row?.data[0]?.id}`)
            }
            const val = u.searchHomecategory(category, row?.channel, row?._name);
            return window.open(`/page/${row?.channel}/${val?.id}`)
        }
        
    }, [category,])

    const hitStatis = useCallback(async (x: any) => {
            const __val = u.getStatsParams(false, "home", x.channel + '-更多-' + x.realName, "") as any;
            console.log(__val , ' --- ', x )
            if (__val?.c && x?.count) {
                __val["c"] = __val["c"] + x?.count;
            }
            reqStats(__val)
    }, [])

    const _memoList = useMemo(() => {
        const _newdata = { ...data };
        delete _newdata["seo"]
        delete _newdata["notice"]
        _newdata["commen_list"] = { ..._newdata["commen_list"], "channel": "shipin" }
        console.log(' home vid list -', _newdata);
        console.log(' home vid list keys -', Object.keys(_newdata));
        console.log(' home vid list values -', Object.values(_newdata));
        return _newdata
    }, [data])

    // console.log(_memoList)

    const PostItem = ({ item }: { item: any }) => {
        const [isExpanded, setIsExpanded] = useState(false);
    
        const toggleExpand = (e: React.MouseEvent) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
        };
    
        return (
            <div className={`${styles.hot_post_item}`} onClick={() => u.open(item.link+ (userInfo.token ? '?mmp='+ userInfo.token : ''))}>
                <Img src={item?.photo} alt="post image" width={32} height={32} cls={`${styles.hot_post_image}`} />
                <div className={`${styles.hot_post_content}`}>
                    <div className={`${styles.hot_post_title}`}>{item.title}</div>
                    <div className={`${styles.hot_post_description_wrapper}`}>
                        <div className={`${styles.hot_post_description} ${!isExpanded ? styles.truncate : ''}`}>
                            {item.content}
                        </div>
                        {/* <button 
                            onClick={toggleExpand}
                            className={`${styles.hot_post_expand}`}
                        >
                            {isExpanded ? '收起' : '展开'}
                        </button> */}
                    </div>
                </div>
            </div>
        );
    };

    console.log("show tupian", TuPian)

    return (
        <div>
            <NoticeModal/>
            <div className="mw1100">
            {TuPian && TuPian?.pic_topics && Array.isArray(TuPian?.pic_topics) && <>
              <div>
              <div className={`${styles.topic_hot}`}>
                                <div className={`${styles.topic_hot_title}`}>
                                    猫咪图库
                                </div>
                                <div className={`${styles.topic_hot_more}`} onClick={() => menuHandler('pic',TuPian.more_topics)}>
                                     更多
                                </div>
                            </div>
                            <div className={`${styles.grid_tupian}`}>
                  {TuPian?.pic_topics.map((card: any, index: any) => (
                    
                    <div
                      key={card.id}
                      className={styles.themePost}
                      onClick={() => menuHandler('pic',card.url)}
                    >
                        
                      <div className={styles.themePostInner}>
                        <div className={styles.themePostImgWrap}>
                          <Img
                            encryptUrl={card.cover}
                            src={card.cover}
                            alt="theme cover"
                            cls={styles.themePostImg}
                          />
                        </div>
                        <div className={styles.themePostContent}>
                          <div>
                            <div className={styles.themePostTitle}>              {card?.title && card.title.length > (u.isMobile() ? 25 : 20)
                ? `${card.title.slice(0, u.isMobile() ? 25 : 20)}...`
                : card.title}</div>
                          </div>
                          <div className={styles.themePostPriceRow} style={{}}>
                            <div>
                              <span className={styles.themePostPrice}>
                                ¥{card.vip_price?.toFixed(2) ?? card.price?.toFixed(2)}
                              </span>
                                <span className={styles.themePostOldPrice}>
                                  ¥{card.price?.toFixed(2)}
                                </span>
                            </div>
                            <div className={styles.themePostCountRow}>
                              <Img
                                cls={styles.count_img}
                                src={appendHost("/images/icon/count.png")}
                                alt="resources"
                              />
                              <span className={styles.themePostCountText}>{card.pic_topic_resources_count}</span>
                            </div>
                          </div>
                        </div>
                        {/* {card.is_new === 1 && (
                          <div className={styles.themePostBadge}>最新</div>
                        )} */}
                      </div>
                      {/* Hover Overlay as direct child */}
                      <div className={styles.themePostHover}>
                        <div className={styles.themePostHoverContent}>
                          <p className={styles.themePostHoverTitle}>{card.title}</p>
                          <div className={styles.themePostHoverInfo}>
                            <div className={styles.themePostHoverInfoRow}>
                              <span>类别：</span>
                              <span>{card.pic_nav?.name || ""}</span>
                            </div>
                            <div className={styles.themePostHoverInfoRow}>
                              <span>照片：</span>
                              <span>{card.image_quantity}张</span>
                            </div>
                            <div className={styles.themePostHoverInfoRow}>
                              <span>更新时间：</span>
                              <span>{new Date(card.update_time * 1000).toLocaleDateString()}</span>
                            </div>
                          </div>
                          <div className={styles.themePostHoverPriceRow}>
                            <div>
                              <span className={styles.themePostHoverPrice}>
                                ¥{card.vip_price?.toFixed(2) ?? card.price?.toFixed(2)}
                              </span>
                              {card.oldPrice && (
                                <span className={styles.themePostHoverOldPrice}>
                                  ¥{card.oldPrice?.toFixed(2)}
                                </span>
                              )}
                            </div>
                            <div className={styles.themePostHoverCountRow}>
                              <img
                                style={{ width: 14, height: 14 }}
                                src="assets/images/count.png"
                                alt="resources"
                              />
                              <span className={styles.themePostHoverCountText}>{card.image_quantity}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
                        </>}


                {_memoList && Object.values(_memoList).map((x: any, i) => {
                    return <div key={i}>
                        <div className={styles.main}>
                            <div className={styles.title}>{x.channel !== 'topic' ? name[i] : x.data[0]?.title}</div>
                            <div onClick={() => handleMore({ ...x, _name: x.channel !== 'topic' ? mapName[i] : x.data[0]?.title, realName: x.channel !== 'topic' ? name[i] : x.data[0]?.title })}>更多</div>
                        </div>
                        <ImageList updateTime={x.channel === 'topic' ? (x?.data[0].update_time) : null} is300={name[i] === '免费福利'} channel={x.channel} imgUrlkey="thumb" idkey="title" idValue="id" list={x.channel !== 'topic' ? x.data : x.data[0]?.list} isHome={true} topicParentId={x?.data && x?.data.length > 0 ? x?.data[0]?.id : 0}/>
                    </div>
                })}

                
             {GongLie && GongLie?.post && Array.isArray(GongLie?.post) && <>
                         <div>
                            <div className={`${styles.topic_hot}`}>
                                <div className={`${styles.topic_hot_title}`}>
                                    猫咪攻略
                                </div>
                                <div className={`${styles.topic_hot_more}`} onClick={() => GongLie.more ? u.open(GongLie.more + (userInfo.token ? '?mm='+ userInfo.token : '')) : menuHandler("luntan")}>
                                     更多
                                </div>
                            </div>

                           <div className={`${styles.gonglie_list_wrapper}`}>
                            <div className={`${styles.gonglie_list}`}>
                                 {GongLie?.post?.slice(0, 6).map((item: any, index: number) => {
                                    const hiddenOnMobile = index > 3 ? "mobilehide" : "";
                                    return (
                                        <div key={item.id} className={hiddenOnMobile}>
                                        <a href={item?.link + '?mm='+ userInfo.token}>
                                            <Img src={item?.photo} alt="post image" width={85} height={85} cls={`${styles.gonglie_img}`} />
                                        </a>
                                        </div>
                                    );
                                    })}
                            </div>
                            </div>
                        </div>
                        </>}

            {PostBarMM && PostBarMM?.post && Array.isArray(PostBarMM?.post) && <>
                         <div>
                            <div className={`${styles.topic_hot}`}>
                                <div className={`${styles.topic_hot_title}`}>
                                    热门帖子
                                </div>
                                <div className={`${styles.topic_hot_more}`} onClick={() => PostBarMM.more ? u.open(PostBarMM.more + (userInfo.token ? '?mm='+ userInfo.token : '')) : menuHandler("luntan")}>
                                     更多
                                </div>
                            </div>
                            <div className={`${styles.hot_posts_list}`}>
                                 {PostBarMM?.post?.slice(0, 6).map((item: any, index: number) => {
                                    const hiddenOnMobile = index > 3 ? "mobilehide" : "";
                                    return (
                                        <div key={item.id} className={hiddenOnMobile}>
                                        <PostItem key={item.id} item={item} />
                                        </div>
                                    );
                                    })}
                            </div>
                        </div>
                        </>}
            </div>
        </div>
    )
}
export default LayoutContent;

const name = ["VIP视频", "专题推荐1", "推荐视频", "专题推荐2","免费福利", "专题推荐3","中文字幕", "亚洲无码", "美女主播"]
const mapName = ["VIP 专区","专题推荐1", "短视频区", "专题推荐2","精彩动漫", "专题推荐3","中文字幕", "亚洲无码", "美女主播"]
// const name = ["VIP视频", "推荐视频", "免费福利", "中文字幕", "亚洲无码", "美女主播"]
// const mapName = ["VIP 专区", "短视频区", "精彩动漫", "中文字幕", "亚洲无码", "美女主播"]
